import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineUserExclamationIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M14.55 12.22a4.9208 4.9208 0 0 0 1.7-3.72 5 5 0 0 0-10 0A4.9197 4.9197 0 0 0 8 12.22a8 8 0 0 0-4.7 7.28 1 1 0 1 0 2 0 5.9999 5.9999 0 0 1 10.2426-4.2426A6 6 0 0 1 17.3 19.5a.9997.9997 0 0 0 1 1 1.0001 1.0001 0 0 0 1-1 8.0001 8.0001 0 0 0-4.75-7.28Zm-3.3-.72a2.9994 2.9994 0 0 1-2.7716-1.852A3 3 0 1 1 11.25 11.5Zm8.5-5a1 1 0 0 0-1 1v2a.9997.9997 0 0 0 1 1 1.0001 1.0001 0 0 0 1-1v-2a1.0002 1.0002 0 0 0-1-1ZM19 11.79a1.0501 1.0501 0 0 0-.29.71 1.0003 1.0003 0 0 0 .29.71c.0972.0883.2088.1594.33.21a.94.94 0 0 0 .76 0 .8999.8999 0 0 0 .54-.54.8395.8395 0 0 0 .08-.38 1.0004 1.0004 0 0 0-.6165-.9294A1.0007 1.0007 0 0 0 19 11.79Z"/>
  </SvgIcon>
}

export default LineUserExclamationIcon
